import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '../../utils/api.service';
import { QuestionType } from '../../models/satisfaction';

@Injectable()
export class QuestionTypeService {

  path = 'question_types';
  constructor(
    private apiService: ApiService,
  ) {
  }

  /**
   * Get available types of assignable to questions
   *
   * @param params Parameters of the request, to help user narrow results
   */
  getAll(params: HttpParams): Observable<QuestionType[]> {
    return this.apiService.get(`${this.path}`, params)
      .pipe(map(data => data['hydra:member'].map(obj => new QuestionType(obj))));
  }
}
